import { defineStore } from "pinia";

export const useQuickViewStore = defineStore("quickView", {
  state: () => ({
    masterProduct: null as Record<string, any> | null,
    manufacturer: null as Record<string, any> | null,
    color: null as string | null,
    size: null as string | null,
    selectedVariant: null as number | null,
    selectedVariantSku: null as string | null,
    images: [] as string[],
    currentImageIndex: 0 as number,
  }),

  actions: {
    nextImage() {
      if (this.images.length > 0) {
        this.currentImageIndex =
          (this.currentImageIndex + 1) % this.images.length;
      }
    },

    previousImage() {
      if (this.images.length > 0) {
        this.currentImageIndex =
          (this.currentImageIndex - 1 + this.images.length) %
          this.images.length;
      }
    },

    reset() {
      this.masterProduct = null;
      this.manufacturer = null;
      this.color = null;
      this.size = null;
      this.selectedVariant = null;
      this.selectedVariantSku = null;
      this.images = [];
      this.currentImageIndex = 0;
    },
  },
});
